module.exports = __webpack_public_path__ + "static/media/laptop.1d4d4e3a.png";